export default "__VITE_ASSET__D4fIDuoo__"